import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GoodsTable } from "../../../helpers/Tables/goodsTable";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import IconDownload from "src/assets/images/icon_download.svg";
import { GoodsForm } from "./addGoods";
import Modal from "@mui/material/Modal";
import { InputLabel, Checkbox, Button, Box } from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import _ from "lodash";
import { GetError } from "src/constant";
import { toast } from "react-toastify";
import {  getAllGoodsInData1 } from "src/thunks/goodsin";
import { Search, Close } from "@mui/icons-material";
import { debounce } from "lodash";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "46%",
  transform: "translate(-50%, -50%)",
  width: "77%",
  height: "100%",
  bgcolor: "background.paper",
  overflowY: "scroll",
};

const GoodsInList = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const { allGoodInData } = useSelector((state) => state.goodsin);

  const { filterAllData } = useSelector((state) => state.goodsin);
  const filterData = filterAllData["goodsIn"];

  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isReview, setIsReview] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchValueSecond, setSearchValueSecond] = useState("");

  /** variable declarations ----------------------------------------------------- **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  let pageSize = 1000;

  /** hooks useEffect ---------------------------------------------------- **/
  useEffect(() => {
    getGoodsInDataFunc(currentPage, isReview, searchValue);
  }, [currentPage, isReview, searchValue]);

  /** handler functions--------------------------------------------------- **/
  const handleClose = () => setOpen(false);

  const getGoodsInDataFunc = async (page, review, refNumber) => {
    try {
      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [filterData?.clientId?.id || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
        currentPage: page,
        status: review ? "Review" : "",
        referenceNumber: refNumber,
      };

      if (filterData?.toDate) {
        data["isDateRange"] = true;
        data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
      }
      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    depotStr,
    clientStr,
    projectStr
  ) => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")}  ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Depot:", depotStr?.name || "All Depot"],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"],
      [],
      [],

      [
        "IN TIME",
        "REF NUMBER",
        "DEPOT",
        "MANAGER",
        "CLIENT",
        "PROJECT",
        "ITEMS",
        "DMG",
        "INTERNAL",
        "EXTERNAL",
        "STATUS",
      ],
      ...tableData.map((row) => {
        return [
          moment(row?.inTime).format("DD-MMM-YYYY, HH:mm") ,
          row?.referenceNumber,
          row?.depotCode,
          row?.projectManager,
          row?.clientName,
          row?.projectName,
          row?.itemCount || 0,
          row?.damagedCount || 0,
          row?.interiorSpace || 0,
          row?.exteriorSpace || 0,
          row.statusValue,
        ];
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `GoodsIn Data ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };
  const saveExcelFileForDepotManager = (
    tableData,
    dateFromStr,
    dateToStr,
    depotStr,
    clientStr,
    projectStr
  ) => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")}  ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Depot:", depotStr || "All Depot"],
      ["Client:", clientStr?.name || "All Cliemt"],
      ["Project:", projectStr?.name || "All Project"],
      [],
      [],

      [
        "IN TIME",
        "REF NUMBER",
        "MANAGER",
        "CLIENT",
        "PROJECT",
        "ITEMS",
        "DMG",
        "INTERNAL",
        "EXTERNAL",
        "STATUS",
      ],
      ...tableData.map((row) => {
        return [
          moment(row?.inTime).format("DD-MMM-YYYY, HH:mm") ,
          row?.referenceNumber,
          row?.projectManager,
          row?.clientName,
          row?.projectName,
          row?.itemCount || 0,
          row?.interiorSpace || 0,
          row?.exteriorSpace || 0,
          row.statusValue,
        ];
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `${moment().format(
      "DD-MMM-YYYY"
    )} GoodsIn Data.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = () => {
    const depot = filterData?.depotId || "All Depot";
    const client = filterData?.clientId || "All Client";
    const project = filterData?.projectId || "All Project";
    const depotName = userDetails?.depots[0]?.name || "";
    if (userDetails?.roles == "DepotManager") {
      saveExcelFileForDepotManager(
        allGoodInData,
        filterData?.fromDate,
        filterData?.toDate,
        depotName,
        client,
        project
      );
    } else {
      saveExcelFile(
        allGoodInData,
        filterData?.fromDate,
        filterData?.toDate,
        depot,
        client,
        project
      );
    }
  };

  const handleChange = (event, value) => {
    setCurrentPage(value); // Update the page when the user clicks on a pagination button
  };

  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setCurrentPage(1);
      setSearchValue(nextValue);
      // getGoodsInDataFunc(currentPage, isReview, nextValue)
    }, 1000),
    []
  );

  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValueSecond(searchText);
    debouncedSave(searchText);
  };

  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  return (
    <>
      <div
        className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
          ? "add-overlay-for-depot-dropdown"
          : ""
          } main-goods-in-tab-div d-flex flex-column ms-3 me-3`}
      >
        {userDetails?.roles == "DepotManager" ? (
          ""
        ) : (
          <div className="row mt-2">
            <div className="col-md-3">
              <div className="d-flex mt-2" style={{ position: "relative" }}>
                <input
                  style={{ position: "relative", width: "100%" }}
                  className="search-input-for-depot-personal-tab"
                  type="text"
                  placeholder="Search by ref number..."
                  value={searchValueSecond}
                  onChange={handleSearchInputChange}
                />
                {searchValueSecond !== "" ? (
                  <Close
                    style={{ cursor: "pointer" }}
                    onClick={handleClearSearchText}
                    className="search-icon-style"
                  />
                ) : (
                  <Search className="search-icon-style" />
                )}
              </div>
            </div>
            <div className="col-md-9 d-flex justify-content-end">
              <div className="show-goodsin-review-checkbox d-flex ">
                <Checkbox
                  checked={isReview}
                  onChange={({ target }) => {
                    setCurrentPage(1);
                    setIsReview(target.checked);
                    // setIsActive(false)
                  }}
                />
                <InputLabel>FOR REVIEW ONLY</InputLabel>
              </div>
            </div>
          </div>
        )}
        <GoodsTable allGoodsInTableData={allGoodInData} />
        <div
          style={{ height: 60 }}
          className="d-flex flex-row align-items-center justify-content-between"
        >
          <div className="d-flex">
            {allGoodInData?.totalPages > 1 && (
              <Pagination
                count={Math.ceil(allGoodInData?.totalItems / pageSize)}
                page={currentPage}
                onChange={handleChange}
                variant="outlined"
                color="primary"
              />
            )}
          </div>
          <div className="d-flex">
            <Button
              variant="outlined"
              className="goodsin-list-btns-style ms-2"
              style={{ marginRight: 10 }}
              startIcon={
                <img src={IconNewRecord} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={() => setOpen(!open)}
            >
              Add new record
            </Button>
            {(userDetails?.roles == "SuperAdmin" ||
              userDetails?.roles == "Admin") && (
                <Button
                  disabled={allGoodInData?.result?.length <= 0 ? true : false}
                  variant="outlined"
                  className={`save-report-btn-style ms-2 ${allGoodInData?.result?.length <= 0 ? "fade-out" : ""
                    }`}
                  startIcon={
                    <img
                      src={IconDownload}
                      width={17}
                      height={17}
                      alt="new"
                    ></img>
                  }
                  type="submit"
                  onClick={() => Print()}
                >
                  Save Report
                </Button>
              )}
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="depot-form-header-style">ADD GOODS IN RECORD</div>
          <GoodsForm
            handleClose={handleClose}
            currentPage={currentPage}
            isReview={isReview}
            searchValue={searchValue}
            getAllGoodsIn={getGoodsInDataFunc}
          />
        </Box>
      </Modal>
    </>
  );
};
export default GoodsInList;
